import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const PageLogoContainerStyles = makeStyles((theme: Theme) => ({
    logoContainer: {
        display: "flex",
        justifyContent: "center"
    },
}));
